import '@vaadin/combo-box';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-combo-box';
@customElement(tagName)
export class TmComboBox extends TmBaseComponent {
    @property()
    public items: Array<{ label: string; value: string } | string> = [];

    @property()
    public filterFunction?: (
        items: Array<{ label: string; value: string } | string>,
        searchTerm: string
    ) => Array<{ label: string; value: string } | string>;

    @property()
    public label?: string;

    @property({ type: Boolean })
    public required = false;

    @property({ type: Boolean })
    public disabled = false;

    @property({ type: String })
    public placeholder?: string;

    @property({ type: Boolean })
    public loading = false;

    @property({ type: String })
    public helperText?: string;

    @state()
    private filteredItems: Array<{ label: string; value: string } | string> = [];

    @state()
    private filterText: string = '';

    protected updated(changedProperties: Map<string | number | symbol, unknown>): void {
        if (changedProperties.has('items')) {
            this.filteredItems = this.items;
        }
    }

    protected render() {
        if (this.filterFunction) {
            return html`<vaadin-combo-box
                .filteredItems=${this.filteredItems}
                .loading=${this.loading}
                .disabled=${this.disabled}
                .required=${this.required}
                .placeholder=${this.placeholder}
                .label=${this.label}
                .autoOpenDisabled=${this.filterText.length === 0}
                .helperText=${this.helperText}
                @filter-changed=${(e: CustomEvent) => {
                    this.filterText = e.detail.value;
                    if (this.filterFunction) {
                        this.filteredItems = this.filterFunction(this.items, e.detail.value);
                    }
                }}
                @value-changed=${(e: CustomEvent) => {
                    const valueChangedEvent = new CustomEvent('value-changed', {
                        detail: e.detail.value,
                    });
                    this.dispatchEvent(valueChangedEvent);
                }}
            ></vaadin-combo-box>`;
        }
        return html`<vaadin-combo-box
            .items=${this.items}
            .loading=${this.loading}
            .disabled=${this.disabled}
            .required=${this.required}
            .placeholder=${this.placeholder}
            .label=${this.label}
            .helperText=${this.helperText}
            @value-changed=${(e: CustomEvent) => {
                const valueChangedEvent = new CustomEvent('value-changed', {
                    detail: e.detail.value,
                });
                this.dispatchEvent(valueChangedEvent);
            }}
        ></vaadin-combo-box>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
                vaadin-combo-box {
                    width: 100%;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmComboBox;
    }
}
